import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Filter, UI_FilterProps } from 'ui/components/2-molecules/Filter/Filter';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import styles from './FilterHero.module.scss';

export interface UI_FilterHeroProps {
	title: string;
	filter?: UI_FilterProps;
}

export const UI_FilterHero: React.FC<UI_FilterHeroProps> = ({ title, filter }) => {
	return (
		<UI_Container width="Standard">
			<div className={styles.FilterHero}>
				<UI_Heading headingLevel="h1" style="xxl">
					{title}
				</UI_Heading>
				{filter && <UI_Filter {...filter}></UI_Filter>}
			</div>
		</UI_Container>
	);
};
